import React, { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Button,
  Fade,
  Paper,
  Divider
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import LoadingImage from '../../components/LoadingImage';

const TirDorseYedekParcaV10: React.FC = () => {
  useEffect(() => {
    document.title = "Ağır Vasıtalar İçin Orijinal Uyumlu Dorse Malzemeleri - Kale Treyler";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', "Dorse kasa tamirinde kullanılan kaliteli hırdavat grupları ve montaj yardımcı malzemeleri.");
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', "Mersin Akdeniz tır yedek parça, dorse stop lambası camı, tır kilitli somun, dorse montaj cıvataları");
    }

    const canonicalLink = (document.querySelector('link[rel="canonical"]') || document.createElement('link')) as HTMLLinkElement;
    canonicalLink.setAttribute('rel', 'canonical');
    canonicalLink.setAttribute('href', 'https://kaletreyler.com/blog/tir-dorse-yedek-parca-secimi-10');
    if (!document.head.contains(canonicalLink)) {
      document.head.appendChild(canonicalLink);
    }
  }, []);

  return (
    <Box sx={{ bgcolor: 'grey.50', py: 8 }}>
      <Container maxWidth="lg">
        <Fade in timeout={800}>
          <Box>
            <Button
              component={RouterLink}
              to="/blog"
              startIcon={<ArrowBack />}
              sx={{ mb: 4, textTransform: 'none', fontWeight: 'bold' }}
            >
              Blog Yazılarına Dön
            </Button>

            <Paper elevation={0} sx={{ p: { xs: 3, md: 6 }, border: '1px solid', borderColor: 'grey.200', borderRadius: 4 }}>
              <Typography variant="overline" color="secondary" sx={{ fontWeight: 'bold', letterSpacing: 1.5 }}>
                Yedek Parça
              </Typography>
              <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 800, mt: 1, mb: 4, fontSize: { xs: '2rem', md: '3rem' }, lineHeight: 1.2 }}>
                Ağır Vasıtalar İçin Orijinal Uyumlu Dorse Malzemeleri
              </Typography>

              <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mb: 4 }}>
                <Typography variant="body2" color="text.secondary">
                  Yayınlanma Tarihi: <strong>6 Temmuz 2026</strong>
                </Typography>
                <Divider orientation="vertical" flexItem />
                <Typography variant="body2" color="text.secondary">
                  Yazar: <strong>Kale Treyler Editör</strong>
                </Typography>
              </Box>

              <Box sx={{ borderRadius: 3, overflow: 'hidden', mb: 6, boxShadow: '0 10px 30px rgba(0,0,0,0.05)' }}>
                <LoadingImage
                  src="/42.png"
                  alt="Ağır Vasıtalar İçin Orijinal Uyumlu Dorse Malzemeleri"
                  style={{ width: '100%', height: 'auto', maxHeight: '500px', objectFit: 'cover' }}
                />
              </Box>

              <Box sx={{ typography: 'body1', color: 'text.primary', lineHeight: 1.8 }}>
                
<Typography variant="body1" paragraph sx={{ mb: 3 }}>Kasa sızdırmazlığının anahtarı olan kapı contaları ve menteşe kilit sistemleri yüksek aşınma direncine sahip paslanmaz veya galvaniz kaplı çelikten seçilmelidir.</Typography>
<Typography variant="h5" component="h2" sx={{ fontWeight: 'bold', mt: 4, mb: 2, color: 'primary.main' }}>Sektörel İnceleme ve Teknik Çözümler</Typography>
<Typography variant="body1" paragraph sx={{ mb: 3 }}>MIG tır parkı servis noktamızda, montaj işlemlerinde mukavemeti yüksek cıvata grupları, somunlar ve araç bakım spreyleri gibi kaliteli yardımcı malzemeler kullanıyoruz.</Typography>
<Typography variant="h5" component="h2" sx={{ fontWeight: 'bold', mt: 4, mb: 2, color: 'primary.main' }}>Uygulama ve Bakım Aşamaları</Typography>
<Typography variant="body1" paragraph sx={{ mb: 3 }}>Tır ve dorse bileşenleri yoğun çalışma koşulları nedeniyle zamanla aşınmaya uğrar. Kalitesiz yedek parçalar sürüş güvenliğini ve taşıma kalitesini riske atabilir.</Typography>
<Typography variant="h5" component="h2" sx={{ fontWeight: 'bold', mt: 4, mb: 2, color: 'primary.main' }}>Verimlilik ve İşletme Analizi</Typography>
<Typography variant="body1" paragraph sx={{ mb: 3 }}>Kaliteli dış plastikler ve montaj malzemeleri tırın ömrünü uzatır ve aşınmalardan kaynaklanan plansız bakım duruş sürelerini en aza indirmeye katkı sağlar.</Typography>
                
                <Typography variant="body1" paragraph sx={{ mt: 4 }}>
                  Mersin Akdeniz bölgesinde ve MIG tır parkı civarında dorse tamir ve bakımı arayan tır filoları ve nakliye profesyonellerine, <RouterLink to="/" style={{ color: '#1e3a8a', fontWeight: 'bold', textDecoration: 'underline' }}>Kale Treyler Frigo</RouterLink> bünyesinde uzman ekibimizle hizmet vermekten memnuniyet duyarız.
                </Typography>

                <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic', borderLeft: '4px solid', borderColor: 'primary.main', pl: 2, py: 1, mt: 4, bgcolor: 'grey.100' }}>
                  Not: Sitemizde yer alan tüm blog içerikleri lojistik sektörü çalışanları için genel bilgilendirme amacıyla hazırlanmıştır. Aracınızın marka ve modeline en uygun özel çözümler için lütfen teknik ekibimizle iletişime geçiniz.
                </Typography>
              </Box>
            </Paper>
          </Box>
        </Fade>
      </Container>
    </Box>
  );
};

export default TirDorseYedekParcaV10;